"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  activeModal: {
    id: null,
    params: {}
  },
  fileCategories: null
};